/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Submit_TitleInputs */

const en_directory_launch_submit_title = /** @type {(inputs: Directory_Launch_Submit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launching something?`)
};

const zh_directory_launch_submit_title = /** @type {(inputs: Directory_Launch_Submit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有新工具发布？`)
};

/**
* | output |
* | --- |
* | "Launching something?" |
*
* @param {Directory_Launch_Submit_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_submit_title = /** @type {((inputs?: Directory_Launch_Submit_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Submit_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_submit_title(inputs)
	return zh_directory_launch_submit_title(inputs)
});
export { directory_launch_submit_title as "directory.launch.submit_title" }